import axios from 'axios'
import { getSavedState, saveState } from '../store-utils'

export const state = {
  cachedDevices: getSavedState('device.devices'),
  selectedDevice: null,
}

export const getters = {
  cachedDevices(state) {
    return state.cachedDevices
  },

  cachedDevicesWithFilters(state, getters, rootState) {
    let cachedDevicesWithFilters = [...(state.cachedDevices || [])]

    if (rootState.filters.device.name) {
      if (rootState.filters.device.searchGroup) {
        cachedDevicesWithFilters = cachedDevicesWithFilters.filter((device) => {
          return device.group.name.toUpperCase().includes(rootState.filters.device.name)
        })
      } else {
        cachedDevicesWithFilters = cachedDevicesWithFilters.filter((device) => {
          return device.name.toUpperCase().includes(rootState.filters.device.name)
        })
      }
    }

    return cachedDevicesWithFilters
  },

  selectedDevice(state) {
    return state.selectedDevice
  },
}

export const mutations = {
  SET_CACHE(state, devices) {
    state.cachedDevices = devices
    saveState('device.devices', devices)
  },

  SET_SELECTED(state, device) {
    state.selectedDevice = device
  },
}

export const actions = {
  selectDevice({ commit, state, rootState }, { device }) {
    commit('SET_SELECTED', device)
  },

  deviceById({ commit, state, rootState }, { deviceId }) {
    let device = state.cachedDevices.filter(
      (device) => device.id === parseInt(deviceId, 10)
    )[0]
    return Promise.resolve(device)
  },

  fetchDevices({ commit, state, rootState }, { clearCache }) {
    // 1. Check if we've already fetched and cachedDevices the user.
    const cachedDevices = state.cachedDevices
    if (!clearCache && cachedDevices) {
      return Promise.resolve(cachedDevices)
    }

    // 2. Fetch the devices from the API and cache it in case
    // we need it again in the future.
    return axios
      .get('/api/services/app/Device/GetAll')
      .then((response) => {
        const devices = response.data.items
        if (devices.length > 0) {
          commit('SET_CACHE', devices)
        }
        return devices
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },

  updateDevice({ commit, dispatch, state, rootState }, { device }) {
    return axios
      .put('/api/services/app/Device/Update', device)
      .then((response) => {
        dispatch('fetchDevices', { clearCache: true }).then((resp) => {
          commit('SET_SELECTED', null)
        })
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },
}
